import { useState } from 'react';
import * as R from 'ramda';

import ElementNavigationIcon from '@atom/components/common/elements/ElementNavigationIcon';
import { SchemaTree } from '@atom/types/schema';

import PreviewAttributeDetails from '../previewInfo/PreviewAttributeDetails';

import PreviewDetailTree from './PreviewDetailTree';

import classes from './previewSubItems.module.css';

const PreviewSubItems = () => {
  const [selectedPreviewSubItem, setSelectedPreviewSubItem] =
    // @ts-ignore
    useState<SchemaTree>({});

  return (
    <>
      <div className={classes.leftBodyPaneHalf}>
        <PreviewDetailTree
          updateSelectedItem={setSelectedPreviewSubItem}
          selectedItem={selectedPreviewSubItem}
        />
      </div>
      <div className={classes.rightBodyPaneHalf}>
        {!R.isEmpty(selectedPreviewSubItem) ? (
          <>
            <div className={classes.iconRow}>
              <div className={classes.elementName}>
                {selectedPreviewSubItem.name}
              </div>
              <ElementNavigationIcon
                key="info"
                value="info"
                icon="info"
                activeView="info"
                setActiveView={() => {}}
              />
            </div>
            <PreviewAttributeDetails
              key={selectedPreviewSubItem.id}
              schema={selectedPreviewSubItem}
            />
          </>
        ) : (
          <div />
        )}
      </div>
    </>
  );
};

export default PreviewSubItems;
